import { Button, Grid2 } from "@mui/material";
import AdvertisementTypes from "components/common/AdvertisementTypes";
import DateInterval from "components/common/form/DateInterval";
import CompanySelect from "components/global/CompanySelect";
import TagSelect from "components/global/TagSelect";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { actions } from "./logic/actions";

class TagSearchForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filmCompanies: [],
            tags: [],
        };
        this.props.runSearch();
    }

    onChangeCompanies = (companies) => {
        this.props.onChangeForm({
            companies,
        });
    };

    onChangeTags = (tags) => {
        this.props.onChangeForm({
            tags,
        });
    };

    onChangeReviewStatus = (value) => {
        this.props.onChangeForm({
            statuses: value,
        });
    };
    onChangeUsers = (value) => {
        this.props.onChangeForm({
            users: value,
        });
    };

    onChangeInterval = (dateInterval) => {
        this.props.onChangeForm({ dateInterval });
    };
    handleOnChangeAdvTypes = (advTypes) => {
        this.props.onChangeForm({ advTypes });
    };
    render() {
        const {
            form: { dateInterval, companies, tags, advTypes },
            runSearch,
            clearForm,
        } = this.props;

        return (
            (<Grid2 container spacing={2}>
                <Grid2 container spacing={3} size={12}>
                    <DateInterval defaultValue={dateInterval} maxWidth={"50%"} onChange={this.onChangeInterval} />
                    <Grid2
                        style={{ marginLeft: 3 }}
                        size={{
                            sm: 12,
                            xs: 12,
                            md: 6,
                            lg: 6,
                            xl: 6
                        }}>
                        <AdvertisementTypes
                            onChange={this.handleOnChangeAdvTypes}
                            placeholder={"Select types"}
                            value={advTypes}
                        />
                    </Grid2>
                </Grid2>
                <Grid2 container spacing={3} size={12}>
                    <Grid2
                        size={{
                            sm: 12,
                            xs: 12,
                            md: 6,
                            lg: 6,
                            xl: 6
                        }}>
                        <TagSelect defaultValue={tags} multiple onChange={this.onChangeTags} />
                    </Grid2>

                    <Grid2
                        size={{
                            sm: 12,
                            xs: 12,
                            md: 6,
                            lg: 6,
                            xl: 6
                        }}>
                        <CompanySelect
                            defaultValue={companies}
                            multiple
                            placeholder={"All companies"}
                            onChange={this.onChangeCompanies}
                        />
                    </Grid2>
                    {}
                    {}
                    {}
                </Grid2>
                <Grid2 size={12}>
                    <Button
                        onClick={runSearch}
                        color={"secondary"}
                        style={{ marginRight: 20 }}
                        size={"small"}
                        variant={"contained"}
                    >
                        Search
                    </Button>
                    <Button size={"small"} onClick={clearForm} variant={"contained"}>
                        Clear{" "}
                    </Button>
                </Grid2>
            </Grid2>)
        );
    }
}

TagSearchForm.propTypes = {
    runSearch: PropTypes.func,
    clearForm: PropTypes.func,
    form: PropTypes.object,
    onChangeForm: PropTypes.func,
};

export default connect(
    ({ statistics }) => ({
        form: statistics.tagsForm,
    }),
    (dispatch) => ({
        runSearch: () => dispatch(actions.RUN_TAGS_QUERY.send()),
        onChangeForm: (payload) => dispatch(actions.ON_CHANGE_TAGS_FORM.call(payload)),
        clearForm: () => dispatch(actions.ON_CLEAR_TAGS_FORM.call()),
    })
)(TagSearchForm);
